(function() { module.exports = this["wp"]["i18n"]; }());